export enum EInvoiceCountDoc {
	"Count" = "CountDocument",
	"CountIncludingSoftDeleted"= "CountIncludingSoftDeletedDocument",
}

export default EInvoiceCountDoc;